// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"655cce42","453":"6675559e","728":"46023daa"}[chunkId] + ".chunk.js";
};